import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { ROLES, getPermLevel } from '../lib/permissions';
import { modules } from '../features/registry';

export function FAB() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const role = useAuthStore((s) => s.role);

  const config = ROLES[role];
  const isActionPage = location.pathname.startsWith('/manejo') || location.pathname.startsWith('/sesiones');

  // FAB on Sesiones and Manejo sub-pages for field roles
  if (!config.fab || !isActionPage) return null;

  const userPerm = getPermLevel(role);

  const fabModules = modules
    .filter((m) => m.showInFAB && m.requiredPermissions.includes(userPerm))
    .sort((a, b) => a.orden - b.orden);

  return (
    <>
      {/* Overlay */}
      {open && (
        <div
          className="fixed inset-0 bg-black/30 z-[38]"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Menu */}
      {open && (
        <div className="fixed bottom-36 right-4 z-[41] flex flex-col gap-2 animate-[fabSlideUp_200ms_ease]">
          {fabModules.map((m) => (
            <button
              key={m.id}
              className="flex items-center gap-2.5 px-4 py-2.5 bg-[var(--bg-primary)] border border-[var(--border-default)] rounded-xl text-sm font-semibold text-[var(--text-primary)] cursor-pointer shadow-lg whitespace-nowrap active:bg-[var(--bg-secondary)]"
              onClick={() => {
                setOpen(false);
                navigate(`/manejo/${m.route}`);
              }}
            >
              <span className="text-xl">{m.icon}</span>
              <span>{m.label}</span>
            </button>
          ))}
        </div>
      )}

      {/* FAB button */}
      <button
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-20 right-4 w-[52px] h-[52px] bg-[var(--status-info)] border-none rounded-full text-white text-2xl cursor-pointer shadow-[0_4px_16px_rgba(26,107,181,0.4)] flex items-center justify-center z-[40] transition-transform duration-150 active:scale-[0.92]"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
          className={`transition-transform duration-200 ${open ? 'rotate-45' : ''}`}
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
      </button>
    </>
  );
}
